import { carousel } from '@pc/components/Carousel'
import { toggleCheckboxSubmit } from '@pc/components/ToggleCheckboxSubmit'

document.addEventListener('DOMContentLoaded', () => {
  // checkbox に check があるか否かで、submit button の活性／非活性を切り替える
  toggleCheckboxSubmit()

  // レコメンドのカルーセル
  const wrapper = document.getElementsByClassName('js-works-carousel-wrapper')
  if (wrapper.length > 0) {
    window.addEventListener('load', () => {
      carousel({
        wrapperSelector: '.js-works-carousel-wrapper',
        itemsSelector: '.js-works-carousel-items',
        itemSelector: '.js-works-carousel-item',
        leftCursorSelector: '.js-works-recommend-prev',
        rightCursorSelector: '.js-works-recommend-next',
        visibleItem: 3,
        gap: 20
      })
    })
  }
})
